/* import __COLOCATED_TEMPLATE__ from './activity-list.hbs'; */
import Component from '@glimmer/component';
import ProjectsActivityListComponent from '../projects/activity-list';
import { action } from '@ember/object';

export default class TeamsActivityListComponent extends ProjectsActivityListComponent {}
